import React, { useEffect, useRef, useState } from "react";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import {
  Replay as IconReload,
  AddBox as IconAdd,
  Edit as IconEdit,
  Check as IconCheck,
  Close as IconClose,
  PictureAsPdf as IconPdf,
  Article as IconFile,
} from "@mui/icons-material";

import TxtBox from "components/Custom/TxtBox";
import Loader from "components/Custom/Loader";

import { LEAVE_STATUS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { CONFIRMS, LABELS, SUCCESS, ERRORS, WARNINGS } from "common/lables";

import { COMMON_JS } from "common/scripts";

let _timer = null;

const LeavePlannerApprove = (props: any) => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);
  const [empList, setEmpList] = useState([]);

  const [fileId, setFileId] = useState("");
  const [users, setUsers] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});

  useEffect(() => {
    if (loading) {
      getEmpList();
    }
  }, [loading]);

  const getEmpList = () => {
    const args = {};
    // API_HANDLER_MASTERS.getEmployeeMaster(args).then((res: any) => {
    //   const response: any = res.response;
    //   const { status } = res;
    //   if (status === 200) {
    //     let list = response.records.map((r) => {
    //       return {
    //         id: r.id,
    //         label: r.empName,
    //       };
    //     });
    //     setEmpList(list);
    //     getRows();
    //   }
    // });
  };

  const getRows = () => {
    const args = { approve: true };
    // API_HANDLER_HOME.getLeavePlanner(args).then((res: any) => {
    //   const response: any = res.response;
    //   const { status } = res;
    //   if (status === 200) {
    //     let list = response.records;
    //     for (let i = 0; i < response.records.length; i++) {
    //       list[i]["slNo"] = i + 1;
    //       if (list[i]["activeStatus"]) {
    //         list[i]["activeStatusText"] = "Yes";
    //       } else {
    //         list[i]["activeStatusText"] = "No";
    //       }
    //     }
    //     setRows(list);
    //     setFilteredRows([]);
    //     setLoading(false);
    //   }
    // });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const columns: GridColDef[] = [
    {
      field: "slNo",
      headerName: "Sl No.",
      width: 100,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    { field: "empName", headerName: "Employee Name", width: 300 },
    { field: "leaveFrom", headerName: "Leave From", width: 200 },
    { field: "leaveTo", headerName: "Leave To", width: 200 },
    { field: "status", headerName: "Status", width: 200 },
    {
      field: "options",
      headerName: "Options",
      width: 150,
      renderCell: (params) => (
        <div className="options">
          {/* <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip> */}
          <Tooltip title={LABELS.APPROVE} placement="bottom">
            <IconButton
              className="iconBtn green"
              onClick={() => onApprove(params.row, LEAVE_STATUS.APPROVE)}
            >
              <IconCheck />
            </IconButton>
          </Tooltip>
          <Tooltip title={LABELS.REJECT} placement="bottom">
            <IconButton
              className="iconBtn red"
              onClick={() => onApprove(params.row, LEAVE_STATUS.REJECT)}
            >
              <IconClose />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const onApprove = (row: any = {}, status = LEAVE_STATUS.APPLIED) => {
    const args = {
      id: row.id,
      empId: row.empId,
      leaveFrom: row.leaveFrom,
      leaveTo: row.leaveTo,
      type: LEAVE_STATUS.APPROVE,
      status,
    };
    // API_HANDLER_HOME.manageLeavePlanner(args).then((res) => {
    //   if (res.status === 200) {
    //     COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
    //     setSelectedRow({});
    //     setManageDialog(false);
    //     reloadGrid();
    //   } else {
    //     COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
    //   }
    // });
  };

  const deleteUser = ({ id }) => {
    // console.log("deleteUser: ", id);
    setRows(null);
    // getUsers();
  };

  const reloadGrid = () => {
    setRows(null);
    setTimeout(() => {
      getRows();
    }, 2000);
  };

  const onSearch = (e: any) => {
    const qry = e.target.value.trim().toUpperCase();
    clearTimeout(_timer);
    _timer = setTimeout(() => {
      let flist = rows.filter((r: any) => {
        return r.empName.toUpperCase().indexOf(qry) > -1;
      });
      // console.log("flist: ", rows, flist, qry);
      if (flist.length === 0) {
        flist = null;
      } else {
        flist = flist.map((f, i) => {
          f.slNo = i + 1;
          return f;
        });
      }
      setFilteredRows(flist);
    }, 150);
  };

  const empListRef: any = useRef();

  // console.log("Users: ", loading, selectedRow.active);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li className="active">{LABELS.LEAVE_PLANNER_APPROVE}</li>
        </ul>
        <h4>{LABELS.LEAVE_PLANNER_APPROVE}</h4>
      </div>

      {rows && (
        <div className="gridOption">
          <TxtBox placeholder={LABELS.SEARCH} onKeyPress={onSearch} />
          <IconButton className="iconBtn" onClick={reloadGrid}>
            <IconReload />
          </IconButton>
          <IconButton
            className="iconBtn"
            onClick={() => {
              setManageDialog(!manageDialog);
              setSelectedRow({});
            }}
          >
            <IconAdd />
          </IconButton>
        </div>
      )}

      <div
        className="grid"
        style={{
          width: "98%",
          height: "80%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {rows ? (
          <DataGrid
            rows={
              !filteredRows ? [] : filteredRows.length > 0 ? filteredRows : rows
            }
            columns={columns}
            rowHeight={50}
            // pageSize={5}
            // rowsPerPageOptions={[5]}
            disableColumnMenu={true}
          />
        ) : (
          <Loader />
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(LeavePlannerApprove);
